module.exports = __webpack_public_path__ + "static/media/cooling-stering-flush-and-fill.f9145a98.svg";